/**
 * @generated SignedSource<<2a587c8edeebb6a916c66e97006d70bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssignSkillsToPersonsModal_company$data = {
  readonly id: string;
  readonly allPersons: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"PersonsPreviewSelector_persons">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "AssignSkillsToPersonsModal_company";
};
export type AssignSkillsToPersonsModal_company$key = {
  readonly " $data"?: AssignSkillsToPersonsModal_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssignSkillsToPersonsModal_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssignSkillsToPersonsModal_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "excludeClientUsers",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        }
      ],
      "concreteType": "PersonTypeConnection",
      "kind": "LinkedField",
      "name": "allPersons",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PersonTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PersonsPreviewSelector_persons"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "allPersons(excludeClientUsers:true,first:10000)"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "4fdd53819fd8302c6fa800a96433ea95";

export default node;
